module.exports = "{{ 'periodic_tasks.repeater_configurator.at_the_following_days' | translate }}:\n{{ TaskDetailsCtrl.taskDetails.repeater_config | daysDisplay }}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/app/components/periodic_tasks/task_details/display_days_of_month.html
// module id = 747
// module chunks = 0